import clsx from 'clsx';
import { ReactNode } from 'react';
import { Section } from '@/components/containers/section';
import { useMediaQuery } from '@/hooks/use-media-query';
import { NavButton } from '@/components/navigation/nav-button';
import { HeaderBackButton } from '@/components/header/header';
import styles from './user-entry-form-container.module.css';
import { Form } from '@/components/form';
import { FieldValues, UseFormReturn, SubmitHandler } from 'react-hook-form';
import { Button } from '../button';
import { useTranslation } from '@/contexts/i18n-context';

interface UserEntryFormContainerProps<T extends FieldValues> {
  title: string;
  description?: string;
  showSupportLink?: boolean;
  children: ReactNode;
  form: UseFormReturn<T>;
  onSubmit: SubmitHandler<T>;
}

export function UserEntryFormContainer<T extends FieldValues>({
  title,
  description,
  children,
  form,
  onSubmit,
  showSupportLink,
}: UserEntryFormContainerProps<T>) {
  const { t } = useTranslation();
  const isMobile = useMediaQuery('--screen-md');

  return (
    <Form className={styles.form} form={form} onSubmit={onSubmit}>
      {isMobile ? (
        <HeaderBackButton to="/login" />
      ) : (
        <NavButton className={styles.backButton} text="common.back" to="/login" />
      )}
      <Section isFormSection={false}>
        <h1 className={clsx('h4', styles.header)}>{title}</h1>
        {description && <p>{description}</p>}
        <div className={styles.formContent}>{children}</div>
        {showSupportLink && (
          <p className={styles.contactSupport}>
            {t('passwordReset.forgot.support.text', {
              link: (
                <Button key="contact-support-button" variant="link" as="a" to="/support">
                  {t('passwordReset.forgot.support.link')}
                </Button>
              ),
            })}
          </p>
        )}
      </Section>
    </Form>
  );
}
